import { jsx, Fragment } from 'react/jsx-runtime';
import { format } from 'date-fns';
import { useLinearLocale } from '../../locale/LocaleContext.mjs';

function FormatWithLinearLocale({
  date,
  formatMap
}) {
  return /* @__PURE__ */ jsx(Fragment, { children: useFormatWithLinearLocale(date, formatMap) });
}
function useFormatWithLinearLocale(date, formatMap) {
  const { locale } = useLinearLocale();
  return format(date, formatMap[locale]);
}

export { FormatWithLinearLocale, useFormatWithLinearLocale };
//# sourceMappingURL=format.mjs.map
